export const TIMEZONELESS_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
